// AppRoutes.jsx
import { Suspense, lazy } from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import { ProbestackSpinner } from "./components/shared/probestack-spinner/Spinner";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const SecurityCenter = lazy(() => import("./pages/SecurityCenter"));
const AIRoutes = lazy(() => import("./pages/AIRoutes"));
const Resilience = lazy(() => import("./pages/Resilience"));
const RAG = lazy(() => import("./pages/RAG"));
const Agents = lazy(() => import("./pages/Agents"));
const Enrichment = lazy(() => import("./pages/Enrichment"));
const Models = lazy(() => import("./pages/Models"));
const Monetization = lazy(() => import("./pages/Monetization"));
const Developers = lazy(() => import("./pages/Developers"));
const Settings = lazy(() => import("./pages/Settings"));
const GitConfig = lazy(() => import("./pages/Configs/GitConfig"));
const GCSConfig = lazy(() => import("./pages/Configs/GCSConfig"));
const ApiStandardLinting = lazy(() => import("./pages/Configs/ApiStandardLinting"));
const ApiCustomLinting = lazy(() => import("./pages/Configs/ApiCustomLinting"));
const AddGitConfig = lazy(() => import("./pages/ConfigActions/AddGitConfig"));
const AddGCSConfig = lazy(() => import("./pages/ConfigActions/AddGCSConfig"));

function ProtectedPageContent() {
    const { pageId, subPage, action } = useParams();

    const pageComponentMap = {
        dashboard: Dashboard,
        security: SecurityCenter,
        routes: AIRoutes,
        resilience: Resilience,
        rag: RAG,
        agents: Agents,
        enrichment: Enrichment,
        models: Models,
        monetize: Monetization,
        developers: Developers,
        settings: Settings,
    };

    //config routing
    if (pageId === "configs") {

        //config actions
        if (action === "add") {
            const addMap = {
                git: AddGitConfig,
                storage: AddGCSConfig,
                // "api-standard-linting": AddApiStandardLinting,
                // "api-custom-linting": AddApiCustomLinting,
            };

            const AddComponent =
                addMap[subPage] ||
                (() => <div>Add page not found: {subPage}</div>);

            return <AddComponent />;
        }
        const configMap = {
            git: GitConfig,
            storage: GCSConfig,
            "api-standard-linting": ApiStandardLinting,
            "api-custom-linting": ApiCustomLinting,
        };

        const ConfigComponent =
            configMap[subPage] ||
            (() => <div>Config not found: {subPage}</div>);

        return <ConfigComponent />;
    }

    const PageComponent =
        pageComponentMap[pageId] ||
        (() => <div>Page not found: /{pageId}</div>);

    return <PageComponent />;
}

export default function AppRoutes() {
    return (
        <Suspense fallback={<ProbestackSpinner/>}>
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/:pageId" element={<ProtectedPageContent />} />
                <Route path="/:pageId/:subPage" element={<ProtectedPageContent />} />
                <Route path="/:pageId/:subPage/:action" element={<ProtectedPageContent />} />
            </Routes>
        </Suspense>
    );
}